// Application and authorization server configuration
export const config = {
  authorization_base_endpoint: process.env.BROKER_ENDPOINT,
  client_id: process.env.BROKER_CLIENT_ID,
  login_endpoint: process.env.BROKER_LOGIN_ENDPOINT,
  requested_scopes: process.env.BROKER_REQUESTED_SCOPES,
};
